module.exports = __webpack_public_path__ + "img/Ks.7f07fd4e.png";